import { __generator } from "tslib";
import { put, select } from 'redux-saga/effects';
import { selectors, withOffset } from '../../Stream';
import { getCurrentMediaSource } from '../selectors';
import { getPostStreamIdFromMediaSource } from '../helpers';
export default function () {
    var mediaSource, streamId, isFetching;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getCurrentMediaSource)];
            case 1:
                mediaSource = _a.sent();
                if (!mediaSource) {
                    return [2 /*return*/];
                }
                streamId = getPostStreamIdFromMediaSource(mediaSource);
                return [4 /*yield*/, select(selectors.isFetching, streamId)];
            case 2:
                isFetching = _a.sent();
                if (isFetching) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, put(withOffset.actions.fetch(streamId))];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=fetchMorePosts.js.map